import { Store } from '@ngrx/store';
import { Component, OnInit, OnDestroy, Input, ViewChild, ElementRef, HostListener } from '@angular/core';
import { ResultboardService } from './../resultboard/resultboard.service';
import { Subscription } from 'rxjs';
import { CashierService } from '../addfund-popup/cashier.service';

@Component({
  selector: 'app-draftchat',
  templateUrl: './draftchat.component.html',
  styleUrls: ['./draftchat.component.scss']
})

@HostListener('scroll', ['$event'])

export class DraftchatComponent implements OnInit, OnDestroy {
  @Input('league') league: any = null;
  @Input('drafters_id') drafters_id: any = '';
  @ViewChild('chat') chat: ElementRef;

  messages = [];
  message = '';
  page = 1;
  filter = 'league_message'; // all, pick_post, league_message
  isMore = false;
  isLoading = false;
  lastScrollHeight = 0;
  draftMessage: Subscription;
  s_isMobileScreen: Subscription;
  isMobile = false;
  isUserAllowedToPost: boolean = false;

  constructor(private _resultboardService: ResultboardService, private store: Store<any>,public _cashierService: CashierService) { }

  ngOnInit() {
    this.s_isMobileScreen = this.store.select('isMobileScreen').subscribe(state => {
      if (state.length > 0) {
        this.isMobile = state[0];
      }
    });
    this._cashierService.verficationInfo().subscribe((res: any) => {
      if (res['status'] === 'success') {
        this.isUserAllowedToPost = res.entities.post_ban == 0;
      }
    });
    this.setupSocket();
    this.getMessages();
  }

  ngOnDestroy() {
    this.s_isMobileScreen.unsubscribe();
  }

  getMessages(clear = false) {
    if (clear) {
      this.messages = [];
      this.page = 1;
    }
    this.isLoading = true;
    const sub = this._resultboardService.getDraftChat(this.league.id, this.filter, this.page).subscribe(res => {
      if (res.entities.length == 20) {
        this.isMore = true;
      } else {
        this.isMore = false;
      }
      res.entities.forEach(m => {
        m.drafters_id = this.htmlDecode(m.drafters_id);
        m.detail = this.htmlDecode(m.detail);
        m.detail = this.unescapeMessage(m.detail);
        this.messages.unshift(m);
      });
      this.scrollToBottom();
      if (this.page == 1 && this.isMore) this.checkMoreMessages();
      sub.unsubscribe();
    });
  }

  htmlDecode(input) {
    const doc = new DOMParser().parseFromString(input, 'text/html');
    return doc.documentElement.textContent;
  }
  
  scrollToBottom() {
    setTimeout(()=>{
      this.chat.nativeElement.scrollTop = this.chat.nativeElement.scrollHeight - this.lastScrollHeight;
      this.isLoading = false;
    },100);
  }


  checkMoreMessages() {
    if (!this.isLoading && this.isMore && this.chat.nativeElement.scrollTop < 40) {
      this.page++;
      this.lastScrollHeight = this.chat.nativeElement.scrollHeight;
      this.getMessages();
    }
  }

  sendMessage() {
    // do something with this.message across socket
    if (this.message.length) {
      const sub = this._resultboardService.postManage(this.message, this.league.id).subscribe(res => {
        sub.unsubscribe();
      });
      this.message = '';
      // this will be done from listener
      // this.messages.unshift({
      //   drafters_id: this.drafters_id,
      //   detail: this.message,
      //   pick_number: 0,
      //   feed_type: 'league_message'
      // });
    }
  }

  inputKey(event) {
    if (event.key == 'Enter') {
      this.sendMessage();
    }
  }

  getHeight(elm, elm2) {
    if (!this.isMobile) {
      return (window.innerHeight - elm.getBoundingClientRect().top - elm2.clientHeight - 20);
    } else {
      return (window.innerHeight - elm.getBoundingClientRect().top - elm2.clientHeight - 70);
    }
  }

  pickNumber(m) {
    if (parseInt(m.pick_number) > 0) {
      return ' (Pick #' + m.pick_number + ')';
    } else {
      return '';
    }
  }

  setupSocket() {
    if (this.draftMessage) this.draftMessage.unsubscribe();
    this.draftMessage = this._resultboardService.draftMessage().subscribe(res => {
      // console.log('draftMessage',res);
      if (this.messages && this.messages[0] && (this.messages[0].drafters_id != res.entities.drafters_id || this.messages[0].detail != res.entities.detail)) {
        // try to prevent duplicate messages
        res.entities.drafters_id = this.htmlDecode(res.entities.drafters_id);
        res.entities.detail = this.htmlDecode(res.entities.detail);
        res.entities.detail = this.unescapeMessage(res.entities.detail);
        this.messages.push(res.entities);
        this.lastScrollHeight = 0;
        this.scrollToBottom();
      }
    });
  }

  changeFilter(f) {
    this.filter = f;
    this.getMessages(true);
  }
  
  unescapeMessage(msg) {
    return msg.replace(/\\u[\dA-F]{4}/gi, function(match) {
      return String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16));
    }).replace(/\\/g, '');
  }
}
